import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminOrganizationsKeys } from 'app/queries/adminOrganizations/adminOrganizationsKeys';
import type { TCall } from './types/TCall';

type TOptionsParams = QueryFunctionContext<ReturnType<typeof adminOrganizationsKeys.options>>;
type TTeamsParams = QueryFunctionContext<ReturnType<typeof adminOrganizationsKeys.teams>>;

export const createFetchOrganizationOptionsQueryFn =
  (call: TCall) =>
  ({ signal }: TOptionsParams) =>
    call(() => cancelOnSignal(AdminService.getAllOrganizationsList(), signal));

export const createFetchOrganizationTeamsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TTeamsParams) =>
    call(() => cancelOnSignal(AdminService.getTeams({ oid: organizationId }), signal));
